import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsPageViews } from '../../../../shared/enums/analytics.enum';
import { EventInteraction, GTMInteractions, SECTIONS } from '../../../../shared/models/Constants';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { Promociones } from '../../models/promociones';
import { ZoomImagePage } from '../zoom-image/zoom-image.page';

@Component({
  selector: 'app-promocion-preview',
  templateUrl: './promocion-preview.component.html',
  styleUrls: ['./promocion-preview.component.scss'],
})
export class PromocionPreviewComponent implements OnInit {

  @Input() promocion: Promociones

  private openModal: any = null;

  constructor(
    private modalController: ModalController,
    private analyticsService: AnalyticsService,
    private sharedAnalyticsS: SharedAnalyticsService,
  ) { }

  ngOnInit() { }

  public async openModalZoom(image: string) {
    this.sendAnalyticScreen()
    this.openModal = await this.modalController.create({
      component: ZoomImagePage
      , mode: 'md'
      , backdropDismiss: true
      , cssClass: 'ion-modal-zoom'
      , componentProps: { Imagen: image }
    })

    await this.openModal.present()
    this.openModal.onDidDismiss()
      .then(() => {
        this.analyticsService.sendEventAnalytics(GTMInteractions.closePromoDetailEvent, EventInteraction)
      })
  }

  private sendAnalyticScreen() {
    this.sharedAnalyticsS.trackPageView(EAnalyticsPageViews.promoDetailView, SECTIONS.TIENDA);
  }

}
